import { Button, Group, Stack, Tabs } from "@mantine/core"
import { useDisclosure } from "@mantine/hooks"
import { IconChartBarPopular, IconLayout, IconPlus } from "@tabler/icons-react"
import { useState } from "react"

import { ScheduleDashboardResponses } from "@costory/types/endpoints/scheduledDashboardConfigurations"
import { ScheduledDigestConfigurationsResponses } from "@costory/types/endpoints/scheduledDigestConfigurations"

import { ScheduledDigestConfigurationsTable } from "@costory/front/components/ScheduledDigestConfigurationsTable"
import { EditScheduledDashboardConfigurationModal } from "@costory/front/pages/ScheduledDigestConfigurations/Dashboards/ConfigurationModal"
import { ScheduledDashboardList } from "@costory/front/pages/ScheduledDigestConfigurations/Dashboards/ScheduledDashboardList"

import { ConfigurationModal } from "./ConfigurationModal"

export const ScheduledDigestConfigurationsPage = () => {
  const [opened, { open, close }] = useDisclosure()
  const [openedDashboard, { open: openDashboard, close: closeDashboard }] =
    useDisclosure()
  const [editingConfiguration, setEditingConfiguration] = useState<
    ScheduledDigestConfigurationsResponses.List[0] | undefined
  >()
  const [editingDashboard, setEditingDashboard] = useState<
    ScheduleDashboardResponses.List[0] | undefined
  >()

  const handleOpenModal = (
    configuration?: ScheduledDigestConfigurationsResponses.List[0],
  ) => {
    setEditingConfiguration(configuration)
    open()
  }

  const editDashboard = (dashboard: ScheduleDashboardResponses.List[0]) => {
    setEditingDashboard(dashboard)
    openDashboard()
  }
  const editSavedView = (
    savedView: ScheduledDigestConfigurationsResponses.List[0],
  ) => {
    setEditingConfiguration(savedView)
    open()
  }
  const onCloseDashboardModal = () => {
    setEditingDashboard(undefined)
    closeDashboard()
  }
  const onCloseSavedViewModal = () => {
    setEditingConfiguration(undefined)
    close()
  }
  const [tabState, setTabState] = useState("saved_views")
  return (
    <Stack>
      <Group justify="end">
        <Button
          onClick={() => {
            setTabState("saved_views")
            handleOpenModal()
          }}
          leftSection={<IconPlus size={16} />}
        >
          Add a scheduled report
        </Button>
        <Button
          onClick={() => {
            setTabState("dashboard")
            openDashboard()
          }}
          leftSection={<IconPlus size={16} />}
        >
          Add a scheduled dashboard
        </Button>
      </Group>
      <Tabs
        value={tabState}
        onChange={(value) => setTabState(value ?? "saved_views")}
      >
        <Tabs.List mb="md">
          <Tabs.Tab value="saved_views" leftSection={<IconChartBarPopular />}>
            Saved Views
          </Tabs.Tab>
          <Tabs.Tab value="dashboard" leftSection={<IconLayout />}>
            Dashboards
          </Tabs.Tab>
        </Tabs.List>
        <Tabs.Panel value="saved_views">
          <ScheduledDigestConfigurationsTable onEdit={editSavedView} />
        </Tabs.Panel>
        <Tabs.Panel value="dashboard">
          <ScheduledDashboardList onEdit={editDashboard} />
        </Tabs.Panel>
      </Tabs>

      <ConfigurationModal
        opened={opened}
        onClose={onCloseSavedViewModal}
        scheduledDigestConfiguration={editingConfiguration}
        initialValues={editingConfiguration ?? {}}
      />
      {openedDashboard && (
        <EditScheduledDashboardConfigurationModal
          opened={openedDashboard}
          onClose={onCloseDashboardModal}
          scheduledDashboardConfiguration={editingDashboard}
        />
      )}
    </Stack>
  )
}
